/* eslint-disable react/no-unused-state */
/* eslint-disable react/forbid-prop-types */
import React, { Component } from "react"
import Slide from "react-reveal/Slide"
import { withStyles } from "@material-ui/styles"
import { Grid } from "@material-ui/core"
import PropTypes from "prop-types"
import Typography from "@material-ui/core/Typography"
import Particles from "react-particles-js"
import WaterBubble from "./WaterBubble/WaterBubble"

import html from "../images/html.svg"
import css from "../images/css.svg"
import react from "../images/react.svg"
import mysql from "../images/mysql.svg"
import hadoop from "../images/hadoop.svg"
import android from "../images/android.svg"
import python from "../images/python.svg"
import javascript from "../images/javascript.svg"
import spring from "../images/spring.svg"
import mongodb from "../images/mongodb.svg"
import aws from "../images/aws.svg"

import b1 from "../images/b1.png"
import b2 from "../images/b2.png"
import b3 from "../images/b3.png"
import b4 from "../images/b4.png"
import b5 from "../images/b5.png"
import b6 from "../images/b6.png"
import b7 from "../images/b7.png"
import b8 from "../images/b8.png"

const styles = (theme) => ({
  root: {
    backgroundColor: "#f6fbff",
    paddingTop: theme.spacing(6),
    [theme.breakpoints.up("sm")]: {
      padding: theme.spacing(12),

      paddingTop: theme.spacing(6),
    },
  },
  skillContainer: {
    paddingBottom: theme.spacing(8),
    marginRight: theme.spacing(6),
    marginLeft: theme.spacing(6),
    [theme.breakpoints.down("sm")]: {
      paddingBottom: theme.spacing(4),
    },
  },
})

class Skill extends Component {
  constructor(props) {
    super(props)
    this.state = { revealed: false }
  }

  render() {
    const skillBubble = []
    const imgDict = [
      { img: html, name: "html", color: "#e44d26", percentage: 10 },
      { img: python, name: "python", color: "#f9a825", percentage: 10 },
      { img: css, name: "css", color: "#1572b6", percentage: 10 },
      { img: javascript, name: "javascript", color: "#e6a329", percentage: 15 },
      { img: mysql, name: "MySQL", color: "#f57f17", percentage: 10 },
      { img: react, name: "react", color: "#61dafb", percentage: 15 },
      { img: android, name: "android", color: "#96c03a", percentage: 36 },
      { img: spring, name: "java", color: "#77bc1f", percentage: 41 },
      { img: hadoop, name: "hadoop", color: "#cccc00", percentage: 41 },
      { img: mongodb, name: "mongodb", color: "#499d4a", percentage: 52 },
      { img: aws, name: "aws", color: "#ff9900", percentage: 52 },
    ]
    const { classes } = this.props
    const { revealed } = this.state
    for (let i = 0; i < imgDict.length; i += 1) {
      const textStyle = {
        color: imgDict[i].color,
        border: `2px solid  ${imgDict[i].color}`,
      }
      skillBubble.push(
        <Grid key={i} item xl={3} md={4} sm={6} xs={12}>
          <WaterBubble
            suffix={i}
            revealed={revealed}
            color={imgDict[i].color}
            image={imgDict[i].img}
            percentage={imgDict[i].percentage}
            name={imgDict[i].name}
          />
          <div className="bubble_text" style={textStyle}>
            {imgDict[i].name}
          </div>
        </Grid>,
      )
    }
    return (
      <div className="skill">
        <div className={classes.root}>
          <Slide top>
            <Typography
              variant="h2"
              fontWeight="fontWeightBold"
              className="sectionHeader"
              gutterBottom
              align="center"
            >
              {" "}
              Skills{" "}
            </Typography>
          </Slide>
          <div className={classes.skillContainer}>
            <Grid container spacing={6}>
              {skillBubble}
            </Grid>
          </div>
        </div>
        <div className="skillbackground">
          <Particles
            params={{
              particles: {
                number: {
                  value: 3,
                  density: {
                    enable: true,
                    value_area: 400,
                  },
                },
                line_linked: {
                  enable: false,
                },
                move: {
                  speed: 1,
                  out_mode: "out",
                },
                interactivity: {
                  detect_on: "window",
                  events: {
                    onhover: {
                      enable: true,
                      mode: "repulse",
                    },
                  },
                },
                shape: {
                  type: ["image"],
                  image: [
                    {
                      src: b1,
                      height: 20,
                      width: 23,
                    },
                    {
                      src: b2,
                      height: 20,
                      width: 20,
                    },
                    {
                      src: b3,
                      height: 20,
                      width: 20,
                    },
                    {
                      src: b4,
                      height: 20,
                      width: 20,
                    },
                    {
                      src: b5,
                      height: 20,
                      width: 20,
                    },
                    {
                      src: b6,
                      height: 20,
                      width: 20,
                    },
                    {
                      src: b7,
                      height: 20,
                      width: 20,
                    },
                    {
                      src: b8,
                      height: 20,
                      width: 20,
                    },
                  ],
                },
                // color: {
                //   value: "#CCC",
                // },
                size: {
                  value: 30,
                  random: false,
                  anim: {
                    enable: true,
                    speed: 4,
                    size_min: 10,
                    sync: false,
                  },
                },
              },
              retina_detect: true,
            }}
          />
        </div>
      </div>
    )
  }
}

Skill.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(Skill)
